import * as React from 'react';

import * as styles from './HeatIndexFooterSection.css';

export const HeatIndexFooterSection: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['wrapper']}>{children}</div>;
};
